<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <section v-if="!loading" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Verify Your Email Address</h1>
          <p>
            You need to verify your email first before you can continue.
          </p>
          <p>
            If you haven't received the email and you've checked your spam
            folder, then you can click on Resend below to resend the email.
          </p>
          <button
            class="button is-primary btn-align no-lh raised has-margin-top-30"
            type="submit"
            :disabled="loading"
            :class="{ 'is-loading': loading }"
            @click="resend"
          >
            Resend
          </button>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import AuthApi from '@/api/auth'
export default {
  name: 'VerifyEmail',
  components: {
    CardComponent
  },
  computed: {
    ...mapGetters(['user'])
  },
  created() {
    this.getUser().then(() => {
      if (this.user.verified) {
        this.$router.push({ name: 'Home' })
      }
      this.loading = false
    })
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    ...mapActions(['getUser']),
    verifyEmail() {
      this.loading = true
      AuthApi.resendVerifyEmail(this.currentUser.id)
        .then(() => {
          this.$buefy.toast.open({
            message: "Check your inbox, we've send you a verification email.",
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Error resending verification email.',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
